import { render, staticRenderFns } from "./trialOrderDetail.vue?vue&type=template&id=5bcdbfe2&"
import script from "./trialOrderDetail.vue?vue&type=script&lang=js&"
export * from "./trialOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./trialOrderDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports